(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacilityBillingDialogController', FacilityBillingDialogController);

    FacilityBillingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FacilityBilling', 'Facility'];

    function FacilityBillingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FacilityBilling, Facility) {
        var vm = this;

        vm.facilityBilling = entity;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.date = false;

        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.facilityBilling.id !== null) {
                FacilityBilling.update(vm.facilityBilling, onSaveSuccess, onSaveError);
            } else {
                FacilityBilling.save(vm.facilityBilling, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:facilityBillingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
